<template>
  <q-page>
    <div class="q-ma-md render-container" v-html="renderedMd"></div>
  </q-page>
</template>

<script>
import { updateCustomMd } from '../../js/customMdParse/customMdParse'

export default {
  name: 'components',
  data () {
    return {
      content: `# Components
Components are one features that makes Submind so powerful and flexible.  At it's core a component
maps some custom syntax in your markdown into something that is rendered in the note preview.
The custom syntax is defined by a regex and what's rendered is some HTML and CSS along with
any javascript that should define the component's behaviour.

Let's jump straight into an example.  Below is a checkbox component.  To define the component in
the markdown, the user can type \`[ ] label\` or \`[x] label\` to create an unchecked or checked
checkbox.  Have a play around in the example below.  If you change the markdown, the preview will
be updated.  Also notice that checking or unchecking the checkbox in the preview will update the
corresponding checkbox code in the markdown!

<iframe src="https://public.submind.io/components/P22btIg7mvzs1tiaKD7f" width="100%" height="480px"></iframe>
<!--<iframe src="http://localhost:8081/components/P22btIg7mvzs1tiaKD7f" width="100%" height="480px"></iframe>-->

<!--So how is this component built up?-->

<!--Components are re-compiled when they are changed in the markdown.  If you markdown around a-->
<!--component then the markdown is re-rendered without affecting the components.-->
`,
      renderedMd: '',
      componentDefinitionAry: []
    }
  },
  mounted () {
    this.renderedMd = updateCustomMd(this.content || '', this.componentDefinitionAry, this.item, null, false, this.saveThrottled) // eslint-disable-line vue/no-side-effects-in-computed-properties
    this.renderedMd = this.renderedMd + '<div style="width: 100%; height: 25vh;"></div>' // eslint-disable-line vue/no-side-effects-in-computed-properties
    // updateComponentHtmlInDOM()
  }
}
</script>

<style scoped>

</style>
